import { useContext } from 'react';
import { StripeTerminalContext } from '@/context/stripe-terminal-context';

export function useStripeTerminal() {
  const context = useContext(StripeTerminalContext);

  if (!context) {
    throw new Error('useStripeTerminal must be used within StripeTerminalProvider.');
  }

  return context;
}
